import React from 'react'
import { Helmet } from 'react-helmet'

import '../css/Projects.css'

import SchoolFeeding from '../assets/img/school-feeding.jpg'

import Volunteer from '../assets/img/volunteer.jpg'

import IGAFacilitation from '../assets/img/iga-facilitation.jpg'
import AcademicSupport from '../assets/img/academic-support.jpg'

export default function Projects() {
  return (
    <div id="projects">
      <Helmet>
        <title>Projects - Enoho Fikir</title>
      </Helmet>

      <h1>Projects</h1>

      <div id="project-list">
        <div className="project-card">
          <img src={ SchoolFeeding } />
          <h2>Nutritional Support: School Feeding</h2>
          <span>We provide breakfast and lunch within the school through the school feeding program 5 days a week to underprivileged students based on school calendar year. The magnitude of poverty particularly the lack access to basic foods has markedly affected children in primary school in terms of high schoo...</span>
          <a href="/">Read More...</a>
        </div>

        <div className="project-card">
          <img src={ IGAFacilitation } />
          <h2>Income Generating Activities (IGA): Facilitation of IGA</h2>
          <span>IGAs tend to give women a higher status within the family and studies generally indicate that the greater the amount of income under women's control, the greater amount devoted to their children's education, health & nutrition. Income of women is mainly used for the increase of the well being of the...</span>
          <a href="/">Read More...</a>
        </div>

        <div className="project-card">
          <img src={ AcademicSupport } />
          <h2>Academic Support: Help Children Succeed Through Educational Support</h2>
          <span>This program provides educational material support and tutorial support to the targeted students using volunteers. We collaborate with other schools and map out scholarship programs or work on sponsorships. We arrange trainings for the teachers to enhance their performance by collaborating with vo...</span>
          <a href="/">Read More...</a>
        </div>

        <div className="project-card">
          <img src={ Volunteer } />
          <h2>How you can contribute: Be a Volunteer</h2>
          <span>Be a Volunteer</span>
          <a href="/">Read More...</a>
        </div>
      </div>
    </div>
  )
}